import React from 'react';
import { Modal } from 'components/organisms/Modal';
import { Button } from 'legacy-components/componets';
import { useWindowSize } from 'hooks';

type Props = {
  isOpen: boolean;
  onClose: () => void;
};

export const PayoutOnboardingInReviewDialog: React.FC<Props> = ({
  isOpen,
  onClose,
}) => {
  const { isMobile } = useWindowSize();

  return (
    <Modal
      titleClassName='text-[22px]'
      isOpen={isOpen}
      onOpenChange={(open) => !open && onClose()}
      onClose={onClose}
      isFullScreen={isMobile}
      title="You're Almost There — Stripe Review in Progress"
      contentClassName={'w-[750px]'}
    >
      <div className='text-gray-700 text-base p-5'>
        <p className='mb-4'>
          Thank you for completing your Stripe account registration — our trusted third-party payment processor. 
          Stripe is currently reviewing your information as part of a regulatory requirement to enable secure online payment processing for lease transactions.
        </p>
        <p className='mb-4'>
          This verification process typically takes 24-48 hours.
          We will notify you as soon as your account is fully approved and ready to begin accepting payments.
        </p>
        <p className='mb-4'>
          Once active, Stripe will allow renters to securely pay their move-in fees online after signing the lease. 
          As a landlord, you'll benefit from:
        </p>
        <ul className='list-disc list-inside mb-4 space-y-1 pl-4'>
          <li>Instant transfer of move-in fee payments</li>
          <li>Secure and seamless payment processing</li>
          <li>Automated tracking of incoming payments</li>
        </ul>
        <p className='mb-6'>
          We appreciate your patience as Stripe completes the approval process.
        </p>
        <div className='flex justify-center'>
          <Button label='Close' onClick={onClose} theme='primary' />
        </div>
      </div>
    </Modal>
  );
};
